import React, { useState, useEffect, useCallback } from "react";
import { Tooltip } from "antd";
import { useCart } from "../../components/CartContext/CartContext";
import { useAuth } from "../../components/AuthContext/AuthContext";
import { message } from "antd";
import { useLoadScript } from "@react-google-maps/api";
import AddressModal from "../../components/Modal/AddressModal/AddressModal";
import CheckoutCartItems from "../../components/Cards/CheckoutCartItems";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { useNotification } from "../../components/Toast/Notification";
import UserInfoCard from "../../components/UserInfosCard/UserInfosCard";
import { SpecialInstructionModal } from "../../components/Modal/SpecialInstructionModal/SepcialInstructionModal";
import axios from "axios";
import { Link } from "react-router-dom";
import { Images } from "../../assets/assets";
import promoCodeServiceInstance from "../../APIs/promoCode";
import promoCodeUsageServiceInstance from "../../APIs/promoCodeUsage";
import { Address } from "../../@types/address";
import addressServiceInstance from "../../APIs/address";
import { LogisticsData } from "../../@types/logistics";
import logisticsServiceInstance from "../../APIs/logistics";

const CheckoutPage: React.FC = () => {
  const { cart, orderReference } = useCart();
  const { notify } = useNotification();
  const { user } = useAuth();

  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [longitude, setLongitude] = useState<number>(0);
  const [latitude, setLatitude] = useState<number>(0);
  const [placeId, setPlaceId] = useState<string>("");
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isCreatingAddress, setIsCreatingAdress] = useState<boolean>(false);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [special_instruction, setSpecialInstruction] = useState<string>("");
  const [isInstructionModal, setInstructionModal] = useState<boolean>(false);
  // const [isDiscountModal, setDiscountModal] = useState<boolean>(false);
  const [promoCodeId, setPromoCodeId] = useState<null>(null);
  const [address_2, setAddress_2] = useState<string>("");

  const [address, setAddress] = useState<Address[]>([]);
  const [selectedAddress, setSelectedAddress] = useState<Address | null>(null);

  const [
    businessParkOrResidentialComplexName,
    setBusinessParkOrResidentialComplexName,
  ] = useState<string>("");

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyB1rIsa_A5keNvPCSqAzVsY92LgLRmfTmI",
    libraries: ["places"],
  });

  const [city, setCity] = useState<string>("");
  const [province, setProvince] = useState<string>("");
  const [postalCode, setPostalCode] = useState<string>("");
  const [street, setStreet] = useState<string>("");
  const [suburb, setSuburb] = useState<string>("");
  // const [address1, setAddress1] = useState<string>("");
  const [address2, setAddress2] = useState<string>("");
  const [address3, setAddress3] = useState<string>("");
  const [userId, setUserId] = useState<number>(0);
  const [addressId, setAddressId] = useState<number>(0);
  const [unitNumber, setUnitNumber] = useState<string>("");
  const [blockNumber, setBlockNumber] = useState<string>("");
  const [blockName, setBlockName] = useState<string>("");
  const [buildingType, setBuildingType] = useState<string>("");
  const [addressType, setAddressType] = useState<string>("");
  const [building_type_name, setBuilding_type_name] = useState<string>("");
  const [street_number, setStreetNumber] = useState<string>("");
  // const [ordersPayload, setOrdersPayload] = useState<any>();
  const [buildingNameOrNumber, setBuildingNameOrNumber] = useState<string>("");
  const [blockNameOrNumber, setBlockNameOrNumber] = useState<string>("");
  const [unitNameOrNumber, setUnitNameOrNumber] = useState<string>("");
  const [newPriceCents, setNewPriceCents] = useState<any>();
  const [newQuoteId, setQuoteId] = useState<string | null>(null);
  const [promoCode, setPromoCode] = useState<string>("");

  const [shippingDiscount, setShippingDiscount] = useState<number>(0);
  const SHIPPING_DISCOUNT_AMOUNT = 50;
  const SHIPPING_DISCOUNT_THRESHOLD = 400;

  useEffect(() => {
    const total = cart.reduce(
      (total, item) => total + item.price * (item.item_quantity || 0),
      0
    );
    setTotalPrice(total);

    if (total >= SHIPPING_DISCOUNT_THRESHOLD) {
      setShippingDiscount(SHIPPING_DISCOUNT_AMOUNT);
    } else {
      setShippingDiscount(0);
    }
  }, [cart]);

  const handleAddressSelect = async (address: Address) => {
    setSelectedAddress(address);

    if (user) {
      try {
        const result = await updateAddressSelected(user?.id || 0, address.id);
      } catch (error) {
        console.error("Error updating selected address:", error);
      }
    }
  };
  const discountedShippingPrice = Math.max(0, newPriceCents - shippingDiscount);

  // const totalAmount = totalPrice + discountedShippingPrice;
  const totalAmount = totalPrice;
  // const total = Math.round((totalPrice + discountedShippingPrice) * 100);

  const total = Math.round(totalPrice * 100);

  // const [appliedPromoCode, setAppliedPromoCode] = useState<any>(null);

  const formattedAmount = totalAmount?.toLocaleString("en-ZA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formattedShippingPrice = newPriceCents?.toLocaleString("en-ZA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const [finalPrice, setFinalPrice] = useState<any>("");
  const totalDiscount = Math.round(finalPrice * 100);

  const finalAfterDiscount = finalPrice.toLocaleString("en-ZA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const saved = totalAmount - finalPrice;
  const finalSavings = saved.toLocaleString("en-ZA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const handlePayment = async () => {
    if (
      address.length === 0 &&
      selectedAddress === null &&
      newQuoteId === null
    ) {
      notify(
        "Please add an address before continuing with the payment!",
        "warn"
      );
      return;
    }

    setIsProcessing(true);
    try {
      if (orderReference && user && newPriceCents && newQuoteId) {
        const response = await axios.post(
          "https://sodastreamapi.azurewebsites.net/paystack/pay",
          {
            email: user?.email,
            amount: totalDiscount ? totalDiscount : total,
            callbackUrl:
              "https://sodastreamapi.azurewebsites.net/paystack/callback",
            products: cart.map((item) => ({
              product_id: item.id,
              product_image: item.image,
              height: item.height,
              width: item.width,
              length: item.length,
              weight: item.weight,
              name: item.name,
              price: item.price,
              quantity: item.item_quantity,
              order_type: item.order_type,
              product_sku: item.sku,
              principle: item.principle,
            })),
            user_id: user.id,
            address_id: selectedAddress?.id,
            shipping_price: discountedShippingPrice,
            shipping_discount: shippingDiscount,
            reference_number: orderReference,
            grand_total: totalDiscount ? totalDiscount : total,
            quote_id: newQuoteId,
            promo_code: promoCode,
            promo_code_id: promoCodeId,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = response.data;
        if (data.authorization_url) {
          window.location.href = data.authorization_url;
          // console.log("Paystack authorization URL:", data.authorization_url);
        } else {
          console.error("Error initializing payment");
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  // const handlePayment = async () => {
  //   if (
  //     address.length === 0 &&
  //     selectedAddress === null &&
  //     newQuoteId === null
  //   ) {
  //     notify(
  //       "Please add an address before continuing with the payment!",
  //       "warn"
  //     );
  //     return;
  //   }

  //   setIsProcessing(true);
  //   try {
  //     if (orderReference && user && newPriceCents && newQuoteId) {
  //       const response = await axios.post(
  //         "http://localhost:5005/paystack/pay",
  //         {
  //           email: user?.email,
  //           amount: totalDiscount ? totalDiscount : total,
  //           // ordersPayload,
  //           callbackUrl:
  //             "http://localhost:5005/paystack/callback",
  //           products: cart.map((item) => ({
  //             product_id: item.id,
  //             product_image: item.image,
  //             height: item.height,
  //             width: item.width,
  //             length: item.length,
  //             weight: item.weight,
  //             name: item.name,
  //             price: item.price,
  //             quantity: item.item_quantity,
  //             order_type: item.order_type,
  //             product_sku: item.sku,
  //             principle: item.principle,
  //           })),
  //           user_id: user.id,
  //           address_id: selectedAddress?.id,
  //           shipping_price: discountedShippingPrice,
  //           shipping_discount: shippingDiscount,
  //           reference_number: orderReference,
  //           grand_total: totalDiscount ? totalDiscount : total,
  //           quote_id: newQuoteId,
  //           promo_code: promoCode,
  //           promo_code_id: promoCodeId,
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       const data = response.data;
  //       if (data.authorization_url) {
  //         window.location.href = data.authorization_url;
  //       } else {
  //         console.error("Error initializing payment");
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //   } finally {
  //     setIsProcessing(false);
  //   }
  // };

  const handleOpenInstructionModal = () => {
    if (address) {
      // setStreet(address?.address_1 || "");
      // setSpecialInstruction(address?.special_instruction || "");
      // setAddressId(address.id);
    } else {
      setSpecialInstruction("");
    }
    setInstructionModal(true);
  };

  const handleOpenModal = (selectedAddress: Address) => {
    if (selectedAddress) {
      setCity(selectedAddress.city);
      setProvince(selectedAddress.province);
      setLatitude(selectedAddress.latitude);
      setLongitude(selectedAddress.longitude);
      setPlaceId(selectedAddress.place_id);
      setPostalCode(selectedAddress.postal_code);
      setUserId(selectedAddress.user_id || 0);
      setAddressId(selectedAddress.id);
      setSuburb(selectedAddress.suburb);
      setBlockNumber(selectedAddress.block_number);
      setBuildingType(selectedAddress.building_type);
      setAddressType(selectedAddress.address_type);
      setUnitNumber(selectedAddress.unit_name_or_number);
      setBlockName(selectedAddress.block_name_or_number);
      setStreet(selectedAddress?.address_1 || "");
      setSpecialInstruction(selectedAddress?.special_instruction || "");
      setBuilding_type_name(selectedAddress?.building_type_name || "");
      setStreetNumber(selectedAddress?.street_number || "");
      setBuildingNameOrNumber(selectedAddress?.building_name_or_number || "");
      setBlockNameOrNumber(selectedAddress?.block_name_or_number || "");
      setUnitNameOrNumber(selectedAddress?.unit_name_or_number || "");
    } else {
      setStreet("");
      setCity("");
      setProvince("");
      setPostalCode("");
      setUserId(0);
      setAddressId(0);
      setSuburb("");
      setSpecialInstruction("");
      setBuildingNameOrNumber("");
      setBlockNameOrNumber("");
      setUnitNameOrNumber("");
      setBuildingNameOrNumber("");
    }

    setIsModalVisible(true);
    setIsCreatingAdress(false);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setIsCreatingAdress(false);
    setStreet("");
    setCity("");
    setProvince("");
    setPostalCode("");
    setUserId(0);
    setAddressId(0);
    setSuburb("");
    setSpecialInstruction("");
    setBuildingNameOrNumber("");
    setBlockNameOrNumber("");
    setUnitNameOrNumber("");
    setBuildingNameOrNumber("");
  };

  const handleCloseDiscountModal = () => {
    // setDiscountModal(false);
  };

  const handleCloseInstructionModal = () => {
    setInstructionModal(false);
  };

  const handleUpdateNote = async () => {
    setIsProcessing(true);

    try {
      const response = await addressServiceInstance.updateSpecialInstruction(
        selectedAddress?.id || 0,
        special_instruction
      );

      if (response.data && user) {
        getUserAddress(user?.id || 0);
        handleCloseInstructionModal();
        notify("Special Instruction successfully updated", "success");
      } else {
        const errorMessage = "Error Special Instruction.";
        message.error(errorMessage);
        notify(errorMessage, "error");
      }
    } catch (error: any) {
      console.error("Failed to update Special Instruction:", error);
      message.error(
        `Error Special Instruction: ${
          error?.response?.data?.message || "Unknown error"
        }`
      );
    } finally {
      setIsProcessing(false);
    }
  };

  const handleCreateAddress = async () => {
    setIsProcessing(true);
    try {
      const addresses: Address = {
        address_1: street,
        city: city,
        province: province,
        country: "ZA",
        postal_code: postalCode,
        user_id: user?.id,
        id: addressId,
        address_type: addressType,
        building_type: buildingType,
        unit_number: unitNumber,
        block_number: blockNumber,
        suburb: suburb,
        block_name: blockName,
        special_instruction,
        longitude,
        latitude,
        place_id: placeId,
        building_type_name,
        street_number,
        building_name_or_number: buildingNameOrNumber,
        block_name_or_number: blockNameOrNumber,
        unit_name_or_number: unitNameOrNumber,
        business_park_or_residential_complex_name:
          businessParkOrResidentialComplexName,
        street_name: blockName,
      };

      const response = await addressServiceInstance.createAddress(addresses);

      if (response.data) {
        handleCloseModal();
        setSelectedAddress(response.data);
        notify("Address successfully created", "success");
        getUserAddress(user?.id || 0);
      } else {
        message.error("Error updating address. No data received from server.");
        notify("Error updating address. Please try again.", "error");
      }
    } catch (error: any) {
      message.error(
        `Error updating address: ${
          error?.response?.data?.message || "Unknown error"
        }`
      );
    } finally {
      setIsProcessing(false);
    }
  };

  const handleUpdateAddress = async () => {
    setIsProcessing(true);
    try {
      const addresses: Address = {
        address_1: street,
        city: city,
        province: province,
        country: "ZA",
        postal_code: postalCode,
        user_id: userId,
        id: addressId,
        address_type: addressType,
        building_type: buildingType,
        unit_number: unitNumber,
        block_number: blockNumber,
        suburb: suburb,
        block_name: blockName,
        special_instruction,
        longitude,
        latitude,
        place_id: placeId,
        building_type_name,
        street_number,
        building_name_or_number: buildingNameOrNumber,
        block_name_or_number: blockNameOrNumber,
        unit_name_or_number: unitNameOrNumber,
        business_park_or_residential_complex_name:
          businessParkOrResidentialComplexName,
        street_name: blockName,
      };

      const response = await addressServiceInstance.editAddress(
        selectedAddress?.id || 0 || 0,
        addresses
      );

      if (response && response.data) {
        const fetchAddress =
          await addressServiceInstance.getPrimaryAddressByUserId(user?.id || 0);
        if (fetchAddress && fetchAddress.data) {
          createLogistics(fetchAddress.data);
          handleCloseModal();

          notify("Address successfully updated", "success");
          setAddress(response.data);
        }
      } else {
        message.error("Error updating address. No data received from server.");
        notify("Error updating address. Please try again.", "error");
      }
      getUserAddress(user?.id || 0);
    } catch (error: any) {
      console.error("Failed to update address:", error);
      message.error(
        `Error updating address: ${
          error?.response?.data?.message || "Unknown error"
        }`
      );
    } finally {
      setIsProcessing(false);
    }
  };

  const [promoApplied, setPromoApplied] = useState(false);

  Math.round(finalPrice * 100);

  const applyPromoCode = async () => {
    setIsProcessing(true);

    if (formattedAmount && user) {
      try {
        const responsePromoCode =
          await promoCodeServiceInstance.getPromoCodeByCode(promoCode);

        if (responsePromoCode.data) {
          const promoCodeId = responsePromoCode.data.id;

          const checkResponse =
            await promoCodeUsageServiceInstance.checkPromoCodeUsage(
              user?.id || 0,
              promoCodeId
            );

          if (checkResponse.data) {
            notify("This promo code has already been used", "error");
            setIsProcessing(false);
            return;
          }

          const promoData = {
            price: totalAmount,
            promoCode: promoCode,
          };

          const response = await promoCodeServiceInstance.applyPromoCode(
            promoData
          );

          if (response.data) {
            setFinalPrice(response.data.finalPrice);
            // setAppliedPromoCode(response.data.promoCode);
            setPromoCodeId(response.data.promoCodeId);

            setPromoApplied(true);
            handleCloseDiscountModal();
            notify("Promo code successfully applied", "success");
          } else {
            notify(
              "Promo code is either expired or usage limit reached",
              "error"
            );
            console.error("Error applying promo code", response.error);
          }
        } else {
          notify("Promo Code could not be found", "error");
          setIsProcessing(false);
          return;
        }
      } catch (error) {
        console.log("Error applying promo code:", error);
      } finally {
        setIsProcessing(false);
      }
    }
  };

  useEffect(() => {
    if (!promoCode) {
      // setAppliedPromoCode(false);
    }
  }, [promoCode, totalAmount, promoApplied]);

  const createLogistics = useCallback(
    async (selectAdd: Address) => {
      if (selectAdd && user) {
        try {
          // Uncomment this block if you want to check the destination

          // const formattedProvince = selectAdd.province
          //   .replace("-", " ")
          //   .toUpperCase();
          // const destinationCheck =
          //   await mainDestination.getDestinationBySuburbAndProvince(
          //     selectAdd.suburb.toUpperCase(),
          //     formattedProvince
          //   );

          // if (destinationCheck.error) {
          //   notify(
          //     "We couldn't find a delivery route to your address. Please update your address or visit the",
          //     "warn",
          //     [{ "store locator": "/store-locator" }]
          //   );

          //   setQuoteId(null);
          //   setNewPriceCents(0);
          //   // setLoading(false);
          //   return;
          // }

          const logisticsData: LogisticsData = {
            orderNumber: orderReference ?? "",
            origin: {
              propertyType: "Business",
              businessName: "SodaStream",
              buildingName: "Building Name",
              geoLocation: {
                streetNumber: "234",
                streetName: "22 Ealing Cres",
                suburb: "Centurion",
                city: "Centurion",
                postalCode: "0046",
                province: "Gauteng",
                country: "South Africa",
                latitude: -26.0449801,
                longitude: 28.0239518,
                placeId: "ChIJE-xM1RBklR4RaHso-lKG_Fc",
              },
            },
            destination: {
              buildingType: selectAdd?.building_type,
              propertyType: selectAdd?.address_type,
              businessName: selectAdd?.block_name_or_number,
              blockNameOrNumber: selectAdd?.block_name_or_number,
              buildingName: selectAdd?.building_name_or_number,
              geoLocation: {
                streetNumber: selectAdd?.street_number,
                streetName: selectAdd?.address_1,
                suburb: selectAdd?.suburb,
                city: selectAdd?.city,
                postalCode: selectAdd?.postal_code,
                province: selectAdd?.province,
                country: "South Africa",
                latitude: selectAdd?.latitude,
                longitude: selectAdd?.longitude,
                placeId: selectAdd?.place_id,
              },
            },
            contacts: [
              {
                firstName: user?.firstName,
                lastName: user?.lastName,
                phoneNumber: user?.phone_number,
                email: user?.email,
              },
            ],
            parcels: cart.flatMap((item) =>
              Array(item.item_quantity).fill({
                name: item.name,
                sku: item.sku || "SKU",
                lengthCm: Math.round(parseFloat(item.length)),
                widthCm: Math.round(parseFloat(item.width)),
                heightCm: Math.round(parseFloat(item.height)),
                weightKg: Math.round(parseFloat(item.weight)),
              })
            ),
            specialInstructions:
              selectedAddress?.special_instruction || "to be fixed",
          };

          const response = await logisticsServiceInstance.createLogistics(
            logisticsData
          );

          if (response.data) {
            if (response.data && typeof response.data === "object") {
              const { grandTotal: priceCents, quoteId } = response.data;
              setQuoteId(quoteId);
              setNewPriceCents(priceCents);

              let shippingPrice = priceCents > 0 ? priceCents : 1;
              setNewPriceCents(shippingPrice);
            } else if (typeof response.data === "string") {
              if (response.data === "No route found") {
                setQuoteId(null);
                // priceCents = 0; // This is causing an error - priceCents is not defined
                notify(
                  "We couldn't find a delivery route to your address. Please update your address or visit the",
                  "warn",
                  [{ "store locator": "/store-locator" }]
                );

                return;
              }
            }
          } else {
            notify(
              "We couldn't find a delivery route to your address. Please update your address or visit the",
              "warn",
              [{ "store locator": "/store-locator" }]
            );

            setQuoteId(null);
          }
        } catch (error) {
          setQuoteId(null);

          console.error("Failed to create logistics:", error);
          notify(
            "We couldn't find a delivery route to your address. Please update your address or visit the",
            "warn",
            [{ "store locator": "/store-locator" }]
          );

          setQuoteId(null);
        } finally {
          // setLoading(false);
        }
      } else {
        notify("Please select a delivery address", "error");
        // setLoading(false);
      }
    },
    [
      user,
      selectedAddress,
      cart,
      orderReference,
      setQuoteId,
      setNewPriceCents,
      notify,
    ]
  );

  const getUserAddress = useCallback(
    async (userId: number) => {
      try {
        const response = await addressServiceInstance.getAddressByUserId(
          userId
        );

        if (response.data) {
          const addresses = Array.isArray(response.data)
            ? response.data
            : [response.data];

          setAddress(addresses);

          const selectedAddressArray = addresses.filter(
            (address) => address.is_selected === true
          );

          const selectedAddr =
            selectedAddressArray.length > 0 ? selectedAddressArray[0] : null;
          setSelectedAddress(selectedAddr);

          // Only call createLogistics if we have a valid selected address
          if (selectedAddr) {
            createLogistics(selectedAddr);

            // Remove this call as it's redundant - we're already setting the selected address
            // handleAddressSelect(selectedAddr);
          }
        } else {
          console.error(response.error);
        }
      } catch (err) {
        console.error("Failed to fetch user address:", err);
        setAddress([]);
        setSelectedAddress(null);
      }
    },
    [setAddress, createLogistics]
  );

  useEffect(() => {
    if (user?.id && address.length <= 0) {
      getUserAddress(user.id);
    }
  }, [user?.id, getUserAddress, address]);

  const updateAddressSelected = async (userId: number, addressId: number) => {
    // setIsAddressLoading(true);
    try {
      if (user) {
        const response = await addressServiceInstance.selectAddress(
          userId,
          addressId
        );

        if (response.data) {
          const selectedAddr = address.find((addr) => addr.id === addressId);

          if (selectedAddr) {
            setSelectedAddress(selectedAddr);

            setTimeout(() => {
              createLogistics(selectedAddr);
            }, 0);
            handleCloseModal();
          }
        } else {
          console.error("an error :", response.error);
        }
      }
    } catch (error) {
      console.error("Failed to update selected address:", error);
    } finally {
      setIsProcessing(false);
      // setIsAddressLoading(false);
    }
  };

  const handleisCreatingAddressModal = () => {
    setIsCreatingAdress(true);
    setIsModalVisible(false);
  };

  const getTooltipMessage = () => {
    if (address.length === 0) {
      return "Please add a delivery address";
    } else if (selectedAddress === null) {
      return "Please select a delivery address";
    } else if (newQuoteId === null) {
      return "Unable to process payment at this time";
    }
    return "";
  };

  const isDisabled =
    selectedAddress === null || newQuoteId === null || address.length === 0;

  return (
    <section>
      <Header
        desktopHeight="60vh"
        title={"CHECKOUT"}
        textBackground="CHECKOUT"
        backgroundImg={Images.RecommendationPageBG}
      />

      <div className="p-2 sm:p-9">
        <div className="flex flex-col md:flex-row md:space-x-4 w-full ">
          <div className=" p-2 w-full sm:w-1/2">
            <div>
              <UserInfoCard
                email={""}
                addresses={address || []}
                handleOpenModal={handleOpenModal}
                handleOpenInstructionModal={handleOpenInstructionModal}
                setSelectedAddress={setSelectedAddress}
                selectedAddress={selectedAddress}
                updateAddressSelected={updateAddressSelected}
                createLogistics={createLogistics}
                isCreatingAddress={isCreatingAddress}
                handleisCreatingAddressModal={handleisCreatingAddressModal}
                handleAddressSelect={handleAddressSelect}
              />
            </div>
          </div>
          <div className="p-2 w-full sm:w-1/2 sm:rounded-lg">
            <div className="">
              <div className="">
                <CheckoutCartItems cart={cart} />
              </div>

              <div className="mt-[0px]">
                <div className="bg-gray-50 flex items-center justify-center">
                  <div className="w-full bg-white overflow-hidden">
                    <div className="p-2 md:p-5">
                      <div className="space-y-4 ">
                        {/* Direct promo code input instead of modal */}
                        <div className="bg-gray-100 p-4 rounded-lg">
                          <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                            <div className="flex-grow">
                              <input
                                type="text"
                                value={promoCode}
                                onChange={(e) =>
                                  setPromoCode(e.target.value.trim())
                                }
                                placeholder="Enter promo code"
                                className="w-full p-2 bg-white border border-gray-800 focus:outline-none focus:ring-1 focus:ring-[#005D6E] rounded-lg"
                              />
                            </div>
                            <button
                              onClick={applyPromoCode}
                              disabled={isProcessing}
                              className="whitespace-nowrap px-4 py-2 bg-[#005D6E] text-white  hover:bg-[#00414C] transition-colors disabled:bg-gray-400 rounded-lg">
                              {isProcessing ? "Applying..." : "Apply Code"}
                            </button>
                          </div>
                          {promoApplied && (
                            <div className="mt-2 text-green-600 text-sm flex items-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4 mr-1"
                                viewBox="0 0 20 20"
                                fill="currentColor">
                                <path
                                  fillRule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                  clipRule="evenodd"
                                />
                              </svg>
                              Code applied successfully!
                            </div>
                          )}
                        </div>

                        <div className="rounded-lg bg-white mt-[-90px] p-6 shadow-sm">
                          <h3 className="mb-4 text-lg font-medium text-[#005D6E]">
                            Order Summary
                          </h3>

                          <div className="space-y-4">
                            <div className="flex justify-between text-gray-700">
                              <span>Subtotal (incl. VAT)</span>
                              <span>R {totalPrice.toFixed(2)}</span>
                            </div>

                            {address.length > 0 && selectedAddress && (
                              <div className="flex justify-between font-medium">
                                <span className="text-gray-800">Shipping</span>

                                <div className="flex flex-col items-end">
                                  <>
                                    <span className="text-xs text-gray-400 line-through">
                                      R {formattedShippingPrice}
                                    </span>
                                    <span className="text-lg text-green-600 font-semibold">
                                      FREE
                                    </span>
                                  </>
                                </div>
                              </div>
                            )}

                            {/* Free Shipping Savings */}
                            {address.length > 0 && selectedAddress && (
                              <div className="flex justify-between text-green-600">
                                <span className="flex items-center gap-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4"
                                    viewBox="0 0 20 20"
                                    fill="currentColor">
                                    <path
                                      fillRule="evenodd"
                                      d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                  Free Shipping Savings
                                </span>
                                <span>-R {formattedShippingPrice}</span>
                              </div>
                            )}

                            {/* Promo Code Savings */}
                            {promoApplied && (
                              <div className="flex justify-between text-green-600">
                                <span className="flex items-center gap-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4"
                                    viewBox="0 0 20 20"
                                    fill="currentColor">
                                    <path
                                      fillRule="evenodd"
                                      d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                  Promo Savings
                                </span>
                                <span>-R {finalSavings}</span>
                              </div>
                            )}

                            <div className="my-2 border-t border-gray-100"></div>

                            {address.length > 0 && selectedAddress && (
                              <div className="flex justify-between font-medium">
                                <div className="flex flex-col">
                                  <span className="text-gray-800">
                                    Grand Total
                                  </span>
                                  <span className="text-xs text-gray-500">
                                    VAT included
                                  </span>
                                </div>
                                <div className="flex flex-col items-end">
                                  {promoApplied ? (
                                    <>
                                      <span className="text-xs text-gray-400 line-through">
                                        R {formattedAmount}
                                      </span>
                                      <span className="text-lg font-semibold text-[#005D6E]">
                                        R {finalAfterDiscount}
                                      </span>
                                    </>
                                  ) : (
                                    <span className="text-lg font-semibold text-[#005D6E]">
                                      R {formattedAmount}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="flex flex-col md:flex-row gap-4 mt-6">
                          <Link
                            to="/cart"
                            className="flex-1 text-center py-3 rounded-lg border border-[#005D6E] text-[#005D6E] hover:bg-gray-100 transition-colors">
                            Return to Shopping
                          </Link>
                          <Tooltip
                            title={isDisabled ? getTooltipMessage() : ""}
                            placement="top"
                            color="#333"
                            visible={isDisabled ? undefined : false}>
                            <button
                              disabled={isDisabled}
                              onClick={handlePayment}
                              className={`flex-1 py-3 rounded-lg text-white transition-colors
      ${
        isDisabled
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-[#005D6E] hover:bg-[#00414C]"
      }`}>
                              {isProcessing
                                ? "Processing..."
                                : "Continue Payment"}
                            </button>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/*  */}

                <div
                  className="flex justify-center flex-col md:flex-row w-full
    space-y-2 md:space-y-0 md:space-x-4 xl:space-x-6">
                  <div className="flex flex-col px-3 py-4 md:p-5 xl:p-6 w-full space-y-4"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SpecialInstructionModal
        isProcessing={isProcessing}
        isInstructionModal={isInstructionModal}
        special_instruction={special_instruction}
        setSpecialInstruction={setSpecialInstruction}
        onClose={() => setInstructionModal(false)}
        handleUpdateNote={handleUpdateNote}
        handleOpenInstructionModal={handleOpenInstructionModal}
        address={selectedAddress}
      />

      {/* Removed DiscountModal component */}

      <AddressModal
        isModalVisible={isModalVisible}
        isCreatingAddress={isCreatingAddress}
        onClose={handleCloseModal}
        street={street}
        address2={address2}
        address3={address3}
        handleCreateAddress={handleCreateAddress}
        city={city}
        province={province}
        postalCode={postalCode}
        isProcessing={isProcessing}
        setStreet={setStreet}
        setAddress1={setStreet}
        setAddress2={setAddress2}
        setAddress3={setAddress3}
        setCity={setCity}
        setPostalCode={setPostalCode}
        setProvince={setProvince}
        handleUpdateAddress={handleUpdateAddress}
        visible={false}
        suburb={suburb}
        setSuburb={setSuburb}
        addressType={addressType}
        setAddressType={setAddressType}
        buildingType={buildingType}
        setBuildingType={setBuildingType}
        unitNumber={unitNumber}
        setUnitNumber={setUnitNumber}
        blockNumber={blockNumber}
        setBlockNumber={setBlockNumber}
        setBlockName={setBlockName}
        blockName={blockName}
        setAddress_2={setAddress_2}
        address_2={address_2}
        place_id={placeId}
        setLatitude={setLatitude}
        setLongitude={setLongitude}
        latitude={latitude}
        longitude={longitude}
        setPlaceId={setPlaceId}
        building_type_name={building_type_name}
        setBuilding_type_name={setBuilding_type_name}
        street_number={street_number}
        setStreetNumber={setStreetNumber}
        businessParkOrResidentialComplexName={
          businessParkOrResidentialComplexName
        }
        setBusinessParkOrResidentialComplexName={
          setBusinessParkOrResidentialComplexName
        }
        buildingNameOrNumber={buildingNameOrNumber}
        setBuildingNameOrNumber={setBuildingNameOrNumber}
        blockNameOrNumber={blockNameOrNumber}
        setBlockNameOrNumber={setBlockNameOrNumber}
        unitNameOrNumber={unitNameOrNumber}
        setUnitNameOrNumber={setUnitNameOrNumber}
        special_instruction={special_instruction}
      />

      <Footer />
    </section>
  );
};

export default CheckoutPage;

// {promoApplied ? (
//   <>
//     <span className="text-xs text-gray-400 line-through">
//       R {formattedAmount}
//     </span>
//     <span className="text-lg font-semibold text-[#005D6E]">
//       R {finalAfterDiscount}
//     </span>
//   </>
// ) : (
//   <span className="text-lg font-semibold text-[#005D6E]">
//     R {formattedAmount}
//   </span>
// )}
